import { BoundingBox } from '../types'

export function pixelToGeo(
  x: number,
  y: number,
  bounds: BoundingBox,
  imageWidth: number,
  imageHeight: number
) {
  const lat = bounds.north - (y / imageHeight) * (bounds.north - bounds.south)

  const long = bounds.west + (x / imageWidth) * (bounds.east - bounds.west)

  return { lat, long }
}
